import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class EpicExploreCardA extends Vue {
    public title: string = 'EpicExploreCardA';

    @Prop({
        default: () => {
            return {
                website: null,
                yonghuId: 1063,
                rate: 8.5,
                stars: 5,
                address: '7030 Woodbine Ave #301, Markham',
                bCard: 'oss.www.saomcma.co',
                company: 'RIFO Holding Group',
                prizes: [
                    'Top Sales Prize',
                    'First Place In RIFO Championship'
                ],
                name: 'Ella',
                title: 'Salesperson'
            };
        }
    })
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    public nav() {
        window.open(this.data.website);
    }
}
